import { render } from "./ItemTitle.vue?vue&type=template&id=7bf996ea&scoped=true"
import script from "./ItemTitle.vue?vue&type=script&lang=js"
export * from "./ItemTitle.vue?vue&type=script&lang=js"

import "./ItemTitle.vue?vue&type=style&index=0&id=7bf996ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf996ea"]])

export default __exports__